import React, { useEffect, useState } from "react";
import {
  AddedDefectEntry,
  Classification,
  ModuleDataInspection,
  SubmissionPayload,
} from "../../../types/Inspection";
import { elDefectsData } from "./defects";
import AccordionWrapper from "./inspection/AccordionWrapper";
import { ModuleSize } from "../../../types/ModuleSize";
import Defects from "./inspection/Defects";
import Remark from "./inspection/Remark";
import Classifications from "./inspection/Classification";
import styled from "styled-components";

const classificationColors: { [key in Classification]: string } = {
  A: "green",
  B: "orange",
  C: "red",
  Q: "purple",
};

const ClassificationBadge = styled.span<{ classification: Classification }>`
  background-color: ${(props) => classificationColors[props.classification]};
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: bold;
  font-size: 1rem;
`;

type ELInspectionFormProps = {
  elInspection?: ModuleDataInspection;
  onSubmit: (payload: SubmissionPayload) => void;
  initialIsOpen?: boolean;
  size: ModuleSize;
};

export const ELInspectionForm: React.FC<ELInspectionFormProps> = ({
  elInspection,
  onSubmit,
  initialIsOpen = false,
  size,
}) => {
  const [isOpen, setIsOpen] = useState(initialIsOpen);
  const [remark, setRemark] = useState("");
  const [addedDefects, setAddedDefects] = useState<AddedDefectEntry[]>([]);
  const [classification, setClassification] = useState<Classification | null>(
    null
  );

  useEffect(() => {
    setClassification(elInspection?.classification ?? null);
    setRemark(elInspection?.remark ?? "");
    setAddedDefects(elInspection?.defects ?? []);

    if (elInspection) {
      onSubmit({
        classification: elInspection.classification,
        remark: elInspection.remark,
        defects: elInspection.defects,
      });
    }
  }, [elInspection]);

  const handleSubmit = (selectedClass: Classification) => {
    setClassification(selectedClass);

    const payload: SubmissionPayload = {
      classification: selectedClass,
      remark,
      defects: addedDefects.map(({ cells, defects }) => ({ cells, defects })),
    };

    onSubmit(payload);
    setIsOpen(false);
  };

  return (
    <AccordionWrapper
      header="EL Inspection"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      headerBadge={
        classification && (
          <ClassificationBadge classification={classification}>
            {classification}
          </ClassificationBadge>
        )
      }
    >
      <Defects
        addedDefects={addedDefects}
        setAddedDefects={setAddedDefects}
        defectsData={elDefectsData}
        size={size}
        bordered={false}
      />
      <Remark remark={remark} setRemark={setRemark} />
      <Classifications
        classification={classification}
        handleSubmit={handleSubmit}
      />
    </AccordionWrapper>
  );
};
